import { removeItem } from 'utils/localStorage';
import { TOKEN_USER, TOKEN_NAME } from 'const';

export function clearToken() {
    removeItem(TOKEN_USER);
    removeItem(TOKEN_NAME);
}
